import { checkHttpStatusAuthCheck } from '../../../actions/utilAction';
import history from '../../../history';
import {
  actionCreator,
  checkHttpStatus,
  jsonApiHeader,
  reportActionTypes,
  GET_MASTERDATABYNAME,
  GET_STAFF_BYLOCATION,
  GET_PATIENT,
  GET_HAS_URLACCESS,
  GET_PATIENTLIST,
  GET_REPORTSBYTYPECATEGORY,  
  GET_PATIENT_BY_LACARE,
  GET_PATIENTLIST_WITHPERMISSION,
} from '../constants/ApiContants';

export const getMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(reportActionTypes.get_masterdata.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log('Master Data response: ', response);
        dispatch(actionCreator(reportActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getMasterData ..', error);
      });
  };
};

export const GetStaffByLocation = (locationIds, isActiveCheckRequired) => {
  let query_params = `?locationIds=${locationIds}&isActiveCheckRequired=${isActiveCheckRequired}`;
  return (dispatch, getState) => {   
    dispatch(actionCreator(reportActionTypes.get_Staff_ByLocation.REQUEST));    
    fetch(`${GET_STAFF_BYLOCATION}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);      
          dispatch(actionCreator(reportActionTypes.get_Staff_ByLocation.SUCCESS, response));        
      })
      .catch(function(error) {
        console.log('get staff by location error', error);
      });
  };
};

export const getPatient = (searchObj) => {
  let query_params = `?locationIds=${searchObj.locationIds}&permissionKey=''&isActiveCheckRequired=${searchObj.isActiveCheckRequired}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(reportActionTypes.get_patient.REQUEST));
    fetch(`${GET_PATIENT}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response..................', response);
        dispatch(actionCreator(reportActionTypes.get_patient.SUCCESS, response));
      })
      .catch(function (error) {

      });
  };
};

export const getPatientByLACare = (searchObj) => {
  let query_params = `?locationIds=${searchObj.locationIds}&isActiveCheckRequired=${searchObj.isActiveCheckRequired}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(reportActionTypes.get_patient.REQUEST));
    fetch(`${GET_PATIENT_BY_LACARE}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response..................', response);
        dispatch(actionCreator(reportActionTypes.get_patient.SUCCESS, response));
      })
      .catch(function (error) {

      });
  };
};

export const getPatientList = (searchObj) => {
  let query_params = `?locationIds=${searchObj.locationIds}&isActiveCheckRequired=${searchObj.isActiveCheckRequired}&isExcludeFullyPaid=${searchObj.isExcludeFullyPaid}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(reportActionTypes.get_patient.REQUEST));
    fetch(`${GET_PATIENTLIST}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response..................', response);
        dispatch(actionCreator(reportActionTypes.get_patient.SUCCESS, response));
      })
      .catch(function (error) {

      });
  };
};

export const getPatientListWithPermission = (searchObj) => {
  let query_params = `?locationIds=${searchObj.locationIds}&isActiveCheckRequired=${searchObj.isActiveCheckRequired}&viewTeamClientsOnly=${searchObj.viewTeamClientsOnly}&isExcludeFullyPaid=${searchObj.isExcludeFullyPaid === undefined ? 'NO' : searchObj.isExcludeFullyPaid}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(reportActionTypes.get_patient.REQUEST));
    fetch(`${GET_PATIENTLIST_WITHPERMISSION}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response..................', response);
        dispatch(actionCreator(reportActionTypes.get_patient.SUCCESS, response));
      })
      .catch(function (error) {

      });
  };
};

export const HasUrlAccess = (url) => {
  let query_params = `?url=${url}`;
  return (dispatch, getState) => {   
    dispatch(actionCreator(reportActionTypes.get_hasurlaccess.REQUEST));    
    fetch(`${GET_HAS_URLACCESS}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode > 200) {
          history.push(`/error404`);
        }
        dispatch(actionCreator(reportActionTypes.get_hasurlaccess.SUCCESS, response));        
      })
      .catch(function(error) {
        console.log('Error...', error);
      });
  };
};


export const GetReportsByTypeCategory = (reportTypeCategory) => {
  let query_params = `?reportTypeCategory=${reportTypeCategory}`;
  return (dispatch, getState) => {   
    dispatch(actionCreator(reportActionTypes.get_reportsbytypecategory.REQUEST));    
    fetch(`${GET_REPORTSBYTYPECATEGORY}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log('response: ', response);      
          dispatch(actionCreator(reportActionTypes.get_reportsbytypecategory.SUCCESS, response));        
      })
      .catch(function(error) {
        console.log('get staff by location error', error);
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/Reports/actions/index.js